import React from 'react';
import {
  Apple,
  Box,
  Car,
  Circle,
  Coins,
  Flower2,
  Heart,
  Leaf,
  Pencil,
  Star,
  type LucideIcon,
} from 'lucide-react';

import type { CountingItemType } from '../../core/types/payloads/counting_collection.types';

const SERENITY_ICON_COLORS = ['#5eead4', '#c084fc', '#38bdf8', '#94a3b8'] as const;

const ITEM_ICON_MAP: Record<CountingItemType, LucideIcon> = {
  apple: Apple,
  pencil: Pencil,
  star: Star,
  car: Car,
  ball: Circle,
  flower: Flower2,
  block: Box,
  coin: Coins,
  heart: Heart,
  leaf: Leaf,
};

export function CountingItemIcon({
  itemType,
  colorIndex = 0,
  size = 22,
}: {
  itemType: CountingItemType;
  colorIndex?: number;
  size?: number;
}) {
  const Icon = ITEM_ICON_MAP[itemType] ?? Circle;
  const color = SERENITY_ICON_COLORS[colorIndex % SERENITY_ICON_COLORS.length];
  return (
    <span
      className="counting-item-icon inline-flex items-center justify-center rounded-md bg-white/80 p-1 shadow-sm ring-1 ring-slate-100 print:bg-white print:ring-[#e2e8f0]"
      aria-hidden
    >
      <Icon size={size} strokeWidth={1.75} color={color} />
    </span>
  );
}
